import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { html, nothing } from 'lit';

export const PageFooter = stateful((props: { content?: Renderable }) => {
  return html`
    <div
      class="fixed bottom-0 z-20 flex items-center justify-between gap-4 border-t border-base-300 bg-base-100/80 p-4 shadow-[0_-8px_24px_-12px_rgb(16_42_49/0.18)] backdrop-blur-md backdrop-saturate-150"
      ${css({
        width: navigator.userAgent.toLowerCase().includes('firefox') ? '-moz-available' : '-webkit-fill-available',
      })}
    >
      ${props.content ?? nothing}
    </div>
  `;
});
